import React, { Component } from 'react';

// ---------------------------------------------------------------------------
// Plan definitions — colors drive the header + column accent styling
// ---------------------------------------------------------------------------
const PLANS = [
  { key: 'lite',  label: 'Lite',  color: '#c0e7e9', bg: '#eefeff' }, // slate
  { key: 'basic', label: 'Basic', color: '#2563eb', bg: '#e9f2ff' }, // blue
  { key: 'pro',   label: 'Pro',   color: '#059669', bg: '#ecfdf5' }, // emerald
  { key: 'ultra', label: 'Ultra', color: '#7c3aed', bg: '#f0edff' }, // violet
];

// value can be: true (check) | false (cross) | 'extra' (charged extra badge) | string (plain text)
const FEATURES = [
  { name: 'ERP Portal Login', values: [true, true, true, true] },
  { name: 'Website Creation/ Hosting + CMS Login', values: [false, true, true, true] },
  { name: 'Website Domain (non-https) - if opted', values: [false, 'extra', 'extra', 'extra'] },
  { name: 'School Management (Data Configuration)', values: [true, true, true, true] },
  { name: 'Teacher Management', values: [true, true, true, true] },
  { name: 'Admission Management (includes Old Data Import, Promote) & Reports', values: [true, true, true, true] },
  { name: 'Fee Management (offline) & Reports', values: [true, true, true, true] },
  { name: 'Online Fees Payment Gateway Integration', values: [false, false, true, true] },
  { name: 'Android & iOS Mobile App (Admin/Teachers/Parents)', values: [true, true, true, true] },
  { name: 'Transport Route Management (non GPS)', values: [false, false, true, true] },
  { name: 'Accounts Management/ Bookkeeping Module (Payment/Receipts/Journals/Contra)', values: [false, false, true, true] },
  { name: 'Certificates (TC, Character Certificate)', values: [true, true, true, true] },
  { name: 'Online Attendance Management', values: [false, true, true, true] },
  { name: 'Leave Management (HRM) for Staff', values: [false, false, true, true] },
  { name: 'Payroll (Salary Slip/Deductions/PF)', values: [false, false, false, true] },
  { name: 'LMS (Learning Management System) - eContent Upload', values: [false, false, true, true] },
  { name: 'Assignment Management - Homework', values: [false, false, true, true] },
  { name: 'Query & Doubt Management', values: [false, false, false, true] },
  { name: 'Complaint Management', values: [false, true, true, true] },
  { name: 'Exam (Online mode)', values: [false, false, false, true] },
  { name: 'Exam Progress Report + Customized Templates', values: [true, true, true, true] },
  { name: 'Gate Pass (Visitor Management) Module', values: [false, false, true, true] },
  { name: 'Library Management', values: [false, false, false, true] },
  { name: 'Extra-Curricular Activity Management', values: [false, false, false, true] },
  { name: 'Assets Management (Inventory)', values: [false, false, false, true] },
  { name: 'Tech Support Mechanism', values: ['Email', 'Email/Phone', 'Email/Phone/Remote', 'Email/Phone/Remote'] },
  { name: 'Tech Issue Tracking (Ticket System)', values: [false, true, true, true] },
  { name: 'Training for Client Staff (Online Mode)', values: [true, true, true, true] },
  { name: 'Training for Client Staff (On Site)', values: [false, '1 time/year', '2 times/year', '4 times/year'] },
  { name: 'Notifications & SMS Pack (chargeable basis)', values: [true, true, true, true] },
];

/*const NOTES = [
  <>For exact plan prices, kindly contact <a href="mailto:bishalc@rkcl.in">bishalc@rkcl.in</a>. We only charge flat annual rates irrespective of student count — no hassles of per-student pricing.</>,
  <>There is <strong>No Refund Policy</strong>.</>,
  <>All payments must be made in advance via UPI ID / UPI QR / NEFT to the RKCL bank account. We do not accept Cash / DD / Cheque. </>,
  <>Once a plan is purchased by a school, plan changes are not allowed for 365 days. Plan upgrades are only possible after 1 year.</>,
];*/

// ---------------------------------------------------------------------------
// Cell renderer
// ---------------------------------------------------------------------------
const Check = () => (
  <span className="cell-icon cell-check" aria-label="Included">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M3 8.5L6.2 11.5L13 4.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </span>
);

const Cross = () => (
  <span className="cell-icon cell-cross" aria-label="Not included">
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
      <path d="M3.5 3.5L12.5 12.5M12.5 3.5L3.5 12.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  </span>
);

function renderCell(value) {
  if (value === true) return <Check />;
  if (value === false) return <Cross />;
  if (value === 'extra') return <span className="badge-extra">Charged Extra</span>;
  return <span className="cell-text">{value}</span>;
}

export class SchoolEasy extends Component {
  render() {
    return (
      <div>
        <div className="benifits_school" id="feature">
          <div className="container">
            <div className="row align-items-center py-lg-5 py-4">
              <div className="pricing-wrap">

                

                {/* ---------------- Table ---------------- */}
                <div className="table-responsive pricing-table-wrap">
                  <table className="pricing-table">
                    <thead>
                      <tr>
                        <th className="col-no">S.No.</th>
                        <th className="col-feature">Features</th>
                        {PLANS.map((plan) => (
                          <th
                            key={plan.key}
                            className="col-plan"
                            style={{ '--plan-color': plan.color, '--plan-bg': plan.bg }}
                          >
                            {plan.label}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {FEATURES.map((feature, i) => (
                        <tr key={feature.name}>
                          <td className="col-no">{i + 1}</td>
                          <td className="col-feature">{feature.name}</td>
                          {feature.values.map((value, j) => (
                            <td
                              key={PLANS[j].key}
                              className="col-plan"
                              style={{ '--plan-bg': PLANS[j].bg , 'width': '175px'}}
                            >
                              {renderCell(value)}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* ---------------- Notes ---------------- 
                <div className="pricing-notes">
                  {NOTES.map((note, i) => (
                    <p key={i}><span className="note-index">Note {i + 1}</span>{note}</p>
                  ))}
                </div>*/}

              </div>
            </div>
          </div>
        </div>

        <style>{`
          .pricing-wrap { width: 100%; }

          /* ---- Heading ---- */
          .pricing-heading {
            text-align: center;
            max-width: 640px;
            margin: 0 auto 2rem;
          }
          .pricing-eyebrow {
            display: inline-block;
            font-size: 0.75rem;
            font-weight: 700;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            color: #2563eb;
            background: #eff6ff;
            border: 1px solid #bfdbfe;
            padding: 0.3rem 0.85rem;
            border-radius: 999px;
            margin-bottom: 0.9rem;
          }
          .pricing-title {
            font-size: clamp(1.6rem, 3vw, 2.3rem);
            font-weight: 800;
            color: #0f172a;
            margin: 0 0 0.6rem;
          }
          .pricing-subtitle {
            font-size: 1rem;
            color: #64748b;
            line-height: 1.6;
            margin: 0;
          }

          /* ---- Table shell ---- */
          .pricing-table-wrap {
            border-radius: 14px;
            overflow: auto;
            box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
            border: 1px solid #e2e8f0;
          }
          .pricing-table {
            width: 100%;
            border-collapse: collapse;
            font-size: 0.92rem;
            background: #fff;
          }

          /* ---- Header row ---- */
          .pricing-table thead th {
            position: sticky;
            top: 0;
            z-index: 2;
            padding: 1rem 0.9rem;
            font-weight: 700;
            font-size: 1rem;
            color: #fff;
            background: linear-gradient(135deg, #8f99aa, #bfc3cd);
            border-bottom: none;
          }
          .pricing-table thead th.col-plan {
            background: linear-gradient(135deg, var(--plan-color), color-mix(in srgb, var(--plan-color) 70%, #000));
            text-align: center;
          }
          .pricing-table thead th.col-no { width: 4%; text-align: center; }
          .pricing-table thead th.col-feature { width: 38%; text-align: left; }

          /* ---- Body rows ---- */
          .pricing-table tbody td {
            padding: 0.75rem 0.9rem;
            border-bottom: 1px solid #eef1f5;
            vertical-align: middle;
          }
          .pricing-table tbody tr:nth-child(even) td.col-feature,
          .pricing-table tbody tr:nth-child(even) td.col-no {
            background: #f8fafc;
          }
          .pricing-table tbody tr:hover td { background: #f1f5f9; }
          .pricing-table tbody tr:hover td.col-plan { background: var(--plan-bg); }

          .col-no { text-align: center; color: #94a3b8; font-weight: 600; }
          .col-feature { text-align: left; color: #1e293b; font-weight: 500; }
          .col-plan { text-align: center; background: var(--plan-bg); }

          /* ---- Icons / badges ---- */
          .cell-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 26px;
            height: 26px;
            border-radius: 50%;
          }
          .cell-check { color: #16a34a; background: #dcfce7; }
          .cell-cross { color: #d92525; background: #f1f5f9; }
          .cell-text { font-weight: 600; color: #334155; font-size: 0.85rem; }
          .badge-extra {
            display: inline-block;
            font-size: 0.72rem;
            font-weight: 700;
            letter-spacing: 0.02em;
            color: #b45309;
            background: #fef3c7;
            border: 1px solid #fde68a;
            padding: 0.25rem 0.6rem;
            border-radius: 999px;
            white-space: nowrap;
          }

          /* ---- Notes ---- */
          .pricing-notes {
            margin-top: 1.5rem;
            background: #fff7ed;
            border: 1px solid #fed7aa;
            border-radius: 12px;
            padding: 1.1rem 1.4rem;
          }
          .pricing-notes p {
            margin: 0 0 0.6rem;
            font-size: 0.88rem;
            color: #9a3412;
            line-height: 1.6;
          }
          .pricing-notes p:last-child { margin-bottom: 0; }
          .pricing-notes a { font-weight: 600; text-decoration: underline; }
          .note-index {
            font-weight: 700;
            color: #ea580c;
            margin-right: 0.4rem;
          }

          @media (max-width: 768px) {
            .pricing-table { font-size: 0.82rem; }
            .pricing-table thead th, .pricing-table tbody td { padding: 0.6rem 0.5rem; }
          }
        `}</style>
      </div>
    );
  }
}

export default SchoolEasy;
